export const API_LABELS_URL = `https://dda9vqf16k9w1.cloudfront.net/get-custom-product-labels`;
export const API_LABEL_KEY_PERSONALIZATION = 'PERSONALIZATION';
